import api from './index';
import { LatestReleaseNote, ReleaseNote } from './types/releaseNote';

export async function fetchLatestReleaseNote(): Promise<LatestReleaseNote | null> {
  const response = await api.get<{ data: LatestReleaseNote | null }>('/release-notes/latest');
  return response.data.data;
}

export async function markReleaseNoteRead(releaseNoteId: string): Promise<void> {
  await api.post(`/release-notes/${releaseNoteId}/read`);
}

export async function fetchAdminReleaseNotes(): Promise<ReleaseNote[]> {
  const response = await api.get<{ data: ReleaseNote[] }>('/admin/release-notes');
  return response.data.data;
}

export async function createReleaseNote(data: {
  title: string;
  bodyMd: string;
}): Promise<ReleaseNote> {
  const response = await api.post<{ data: ReleaseNote }>('/admin/release-notes', data);
  return response.data.data;
}
